import React, {  useEffect } from 'react';
import {Button, Container, Navbar, Nav, Image} from 'react-bootstrap';
import logo from './FrameNo.webp';
import '../css/components/Topnav.scss';
const getApiUrl = (path = "") => {
  const isProd = /^(www\.)?nomadcredit\.com$/.test(window.location.hostname);
  const subdomain = isProd ? "prod" : "stagingapi";
  return `https://${subdomain}.nomadcredit.com${path}`;
};
const Topnav = (props) => {
      const searchParams = new URLSearchParams(window.location.search);
      let btnStyle = { padding:'8px 50px'};
      let logoStyle = {};
      let {loggedin} = props;
      btnStyle = { padding:'8px 50px', marginTop:'30px'};
      logoStyle ={margin:'auto'};
      const dashboard = searchParams.get("dashboard")
      const mydocs = searchParams.get("mydocs")
    

      return(
        <Navbar className="top-nav"  expand="lg">
          <Container className='position-relative'>
            <Navbar.Brand className={loggedin ? '' : 'landing-logo'} style={logoStyle}><Image fluid={true}  alt='Nomad Credit Logo' src={logo} width={200} height={74}/></Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <div style={{width:'85%'}} className={loggedin ? '':'d-none'}>
            <Navbar.Collapse id={`basic-navbar-nav`} >
              <Nav className={`me-auto`}>
                  <Nav.Link href="#" className='mobile-link' onClick={(e) => {
                    e.preventDefault()
                  fetch(`/signout.php`)
                  .then(response => response.json())
                  .then(response => {
                      response = response.data;
                      window.location.href = '/sign-in?sign_in=true'
                  })
                  .catch(error => {
                      console.log('error', ""+error);
                  });
                }}>Log Out</Nav.Link>
                  {/* <Nav.Link href="/contact-us">Contact Us</Nav.Link> */}
                  {/* <Nav.Link active={dashboard} href="/app?dashboard=true">Dashboard</Nav.Link> */}
                  {/* <Nav.Link href="/faqs">FAQs</Nav.Link> */}
                 {/* <Nav.Link
                active={mydocs}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const url = getApiUrl("/api/v1/student/generate_magic_link");
                  fetch(url, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${localStorage.getItem(
                        "access_token"
                      )}`,
                    },
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      if (data?.magic_link) {
                        window.location.href = data.magic_link;
                      } else {
                        console.error(
                          "Error generating magic link:",
                          data.message
                        );
                      }
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                }}
                className="nav-element"
              >
                Upload Documents
              </Nav.Link> */}
                  {/* <Nav.Link  href="/blog" target='_blank'>Articles</Nav.Link> */}
              </Nav>
            </Navbar.Collapse>
              </div>
            <Nav className='top-nav-login'>
                  {/* {window.seshName ? 
                  <Button style={btnStyle} href='/sign-up' variant="outline-danger" size="lg">Sign Out</Button> :
                  <Button style={btnStyle} href='/sign-up' variant="outline-danger" size="lg">Sign Up</Button>
                } */}
                <Button style={btnStyle} className={loggedin ? '':'d-none'} href='' onClick={(e) => {
                  e.preventDefault()
                  localStorage.removeItem('access_token');
                  fetch(`/signout.php`)
                  .then(response => response.json())
                  .then(response => {
                      response = response.data;
                      window.location.href = '/sign-in?sign_in=true'
                  })
                  .catch(error => {
                      console.log('error', ""+error);
                  });
                }} variant="outline-danger" size="lg">Sign Out</Button>
                </Nav>
          </Container>
        </Navbar>
      )
      
      



}

export default Topnav
